// @flow
// @jsx h
import { h, Component } from "preact";
import $ from "jquery";
import { Text } from "preact-i18n";
import styles from "./ParticipantClientForm.scss";
import { PrimaryButton } from "elc-button";
import { addParticipantClientData, createParticipants } from "elc-open-api";
// import FormInput from "./forminput";
import { FormInput } from "elc-client-forms";
import { isValidPhoneNumber } from "react-phone-number-input";

import inputsValidation from "./inputsValidation";

type ParticipantClientFormProps = {
  infoPerParticipant: boolean,
  name: string,
  status: string,
  id: number,
  _embedded: {
    clientFormFields: Array<{
      mandatory: boolean,
      id: number,
      _embedded: {
        clientFormInputType: {
          inputType: string,
          label: string,
          id: number,
          _embedded: ?{
            options: {
              Madame: string,
              Monsieur: string
            }
          }
        }
      }
    }>
  },
  onParticipantSaved: Function,
  clientData: any[],
  currentTheme: any,
  locale:string
};

type ClientDetailsState = {
  participantClientData: ParticipantClientData,
  inputErrors: Array<number>
};

let tmpCurrentIndex = [];

export default class ParticipantClientForm extends Component<
  ParticipantClientFormProps,
  ClientDetailsState
> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      participantClientData: props.clientData,
      inputErrors: [],
      emailConfirm:false
    };
  }

   validate()  {
    // tu délègues la logique à ta fonction importée
   
    // console.log("this.props.participantClientForm._embedded.clientFormFields ---- validate", this.props.participantClientForm._embedded.clientFormFields)
    // console.log("this.props.clientData ---- validate", this.props.clientData)
     
    let inputErrors = inputsValidation(
        this.props.participantClientForm._embedded.clientFormFields,
        this.state.participantClientData,
        this.state.inputErrors,
        this.state.emailConfirm
      ) 
      this.setState(prevState => ({
          inputErrors:  inputErrors
        }));

    const isValid = inputErrors.length === 0;
    this.isFormValid(inputErrors, true);
    
    if(this.props.pageDidMountOrUpdate){
      this.props.pageDidMountOrUpdate()
    }    
    return isValid;
  }

isFormValid = (inputErrors, forceUpdate) => {
  //  console.log("isFormValid - this.props.participantClientForm._embedded.clientFormFields",this.props.participantClientForm._embedded.clientFormFields) 
  //  console.log("isFormValid - this.state.participantClientData,",this.state.participantClientData) 
  //  console.log("isFormValid - this.state.inputErrors",this.state.inputErrors) 
  //  console.log("isFormValid - this.state.isMandatoryfield",this.state.isMandatoryfield) 

  this.props.isFormValid(inputErrors.length == 0, this.props.participantIndex + 1, forceUpdate) 

  if(inputErrors.length === 0 && forceUpdate){
        const participant = this.state.participantClientData
          .filter(
            (participant) =>
              participant.clientFormInputType.inputType != "EMAILCONFIRM",
          )
          .map((data) => {
            // Si la valeur est vide → on exclut (ne renvoie rien)
            if ((data.value?.trim() ?? "") === "") {
              return undefined;
            }

            // Sinon, on garde la donnée formatée
            return {
              value: data.value,
              clientFormInputType: {
                id: data.clientFormInputType.id,
                type: data.clientFormInputType.type,
              },
            };
          })
            // Supprime les éléments undefined produits par le map
            .filter((item) => !!item);
                addParticipantClientData(
                  this.props.bookingId,
                  this.props.participantIndex + 1,
                  participant
                )
                  .then(savedData => {

                       this.props.onParticipantSaved(
                      this.props.participantIndex,
                      savedData._embedded.participantClientData
                    );
                    return savedData._embedded.participantClientData;
                  })
                  .catch(error => {
                    console.error("Error addParticipantClientData", error);
                  })
  }
  

  


}

handleInputOnBlur = (inputValue) => {

 const field = this.props.participantClientForm._embedded.clientFormFields
            .filter(
              clientFormField =>
                clientFormField._embedded.clientFormInputType.id == inputValue.clientFormInputType.id 
            );
        if(inputValue.clientFormInputType.inputType === "EMAIL" || inputValue.clientFormInputType.inputType === "EMAILCONFIRM"){
          let arrayInputValue = []  
          let keyType = inputValue.clientFormInputType.inputType
          switch (keyType) {
            case "EMAIL":
                let emailConfirm = this.state.participantClientData.find(emailField => emailField.clientFormInputType.inputType === "EMAILCONFIRM");
                if(emailConfirm !== undefined){
                    arrayInputValue.push(emailConfirm)
                } 
              break;

            case "EMAILCONFIRM":
                let isEmailField = ({ clientFormInputType }) => {
                  return clientFormInputType.inputType === "EMAIL" || clientFormInputType.code === "email";
                };

                let email = this.state.participantClientData.find(isEmailField);
                //console.log("Email", email)
                if(email !== undefined){
                    arrayInputValue.push(email)
                } 
              break;

          }  
          arrayInputValue.push(inputValue);
          inputValue = arrayInputValue

        }
        this.setState(prevState => {
            const updatedErrors = inputsValidation(
              field,
              Array.isArray(inputValue) ? inputValue : [inputValue],
              prevState.inputErrors,
              prevState.emailConfirm
              );

            return { inputErrors: updatedErrors};
        },
      () => {
        if(this.state.isMandatoryfields){
            let inputErrors = inputsValidation(
            this.props.participantClientForm._embedded.clientFormFields,
            this.state.participantClientData,
            this.state.inputErrors,
            this.state.emailConfirm
          );

          this.isFormValid(inputErrors, false);
        }
      });
      
}



  handleInputChange = (inputValue) => {
    inputValue.participantIndex = this.props.participantIndex + 1;

    this.setState(
      prevState => {
        const updatedData = prevState.participantClientData
          .filter(
            value => value.clientFormInputType.id !== inputValue.clientFormInputType.id 
          )
          .concat(inputValue);
          if (prevState.participantClientData === updatedData) {
            return null;
          }

        return { participantClientData: updatedData };
      },
      () => {

          
 const field = this.props.participantClientForm._embedded.clientFormFields
            .filter(
              clientFormField =>
                clientFormField._embedded.clientFormInputType.id == inputValue.clientFormInputType.id 
            );

        if(inputValue.clientFormInputType.inputType === "EMAIL" || inputValue.clientFormInputType.inputType === "EMAILCONFIRM"){
          let arrayInputValue = []  
          let keyType = inputValue.clientFormInputType.inputType
          switch (keyType) {
            case "EMAIL":
                let emailConfirm = this.state.participantClientData.find(emailField => emailField.clientFormInputType.inputType === "EMAILCONFIRM");
                if(emailConfirm !== undefined){
                    arrayInputValue.push(emailConfirm)
                } 
              break;

            case "EMAILCONFIRM":
                let isEmailField = ({ clientFormInputType }) => {
                  return clientFormInputType.inputType === "EMAIL" || clientFormInputType.code === "email";
                };

                let email = this.state.participantClientData.find(isEmailField);
                //console.log("Email", email)
                if(email !== undefined){
                    arrayInputValue.push(email)
                } 
              break;

          }  
          arrayInputValue.push(inputValue);
          inputValue = arrayInputValue

        }

      // console.log("this.state.inputErrors", this.state.inputErrors)
      if(
        this.state.inputErrors.length > 0 ||
        !Array.isArray(inputValue) && inputValue.clientFormInputType.inputType === "SELECT" 
        ) {
        this.setState(prevState => {
            const updatedErrors = inputsValidation(
              field,
              Array.isArray(inputValue) ? inputValue : [inputValue],
              prevState.inputErrors,  
              prevState.emailConfirm
            );

            return { inputErrors: updatedErrors };
        });
      }
            

        // console.log("State updated after handleInputChange, render should have been called.", this.state.participantClientData);
      });
  };

  handleSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
    this.validate();
  };
  
componentDidMount() {
  let isMandatoryfields = this.props.participantClientForm._embedded.clientFormFields.some(item => item.mandatory === true);
  // console.log("isMandatoryfield", isMandatoryfields)
  this.setState({isMandatoryfields})

}


  componentDidUpdate(prevProps, prevState) {
    
  if (JSON.stringify(prevProps.clientData) !== JSON.stringify(this.props.clientData)) {
    //console.log("clientData mise à jour :", this.props.clientData);
            // Initialise participantClientData depuis les props
      const participantClientData = this.props.clientData;
    // Mets à jour le state
      this.setState(
        { participantClientData },
        () => {
        //  Si le champ phone existe, calcule isValid et trigger handleInputChange
          const formDataPhone = participantClientData.find(
            data => data.clientFormInputType.code === 'phone'
          );

          if (formDataPhone) {
            const formDataPhoneWithIsValid = {
              ...formDataPhone,
              isValid: isValidPhoneNumber(formDataPhone.value),
            };
            this.handleInputChange(formDataPhoneWithIsValid);
          }
        }
      );
  }

  }


  render({ participantClientForm, oneProductOneParticipant, currentTheme, locale}, {participantClientData, inputErrors, emailConfirm} ) {
    // const { participantClientForm } = this.props;
    // const { participantClientData, inputErrors } = this.state;

    return (
      <div key={this.props.key} class={styles.participantForm}>


        <form onSubmit={this.handleSubmit} autoComplete="off">
          {participantClientForm &&
            participantClientForm._embedded.clientFormFields.map(
              clientFormField => (
                <div>
                  {/* <pre>{JSON.stringify(emailconfirmvalue)}</pre> */}
                <FormInput
                  key={clientFormField.id}
                  clientFormField={clientFormField}
                  handleInputChange={this.handleInputChange}
                  handleInputOnBlur={this.handleInputOnBlur}
                  value={
                    participantClientData.find(
                      data =>
                        data.clientFormInputType.id ===
                        clientFormField._embedded.clientFormInputType.id
                    )
                      ? participantClientData.find(
                          data =>
                            data.clientFormInputType.id ===
                            clientFormField._embedded.clientFormInputType.id
                        ).value
                      : undefined
                  }
                  emailconfirmvalue={
                    participantClientData.find(
                      data =>
                        (data.clientFormInputType.inputType === "EMAILCONFIRM" || data.clientFormInputType.code === "emailconfirm") && clientFormField._embedded.clientFormInputType.inputType === "EMAIL"
                    )
                      ? participantClientData.find(
                          data =>
                            (data.clientFormInputType.inputType === "EMAILCONFIRM" || data.clientFormInputType.code === "emailconfirm") && clientFormField._embedded.clientFormInputType.inputType === "EMAIL"
                        ).value
                      : undefined
                  }
                  error={inputErrors.length > 0
                      ? inputErrors.find(
                          inputError =>
                            inputError?.id === clientFormField._embedded.clientFormInputType.id
                        )
                      : false}
                  locale={locale}
                  emailConfirm={emailConfirm}
                />
                </div>
              )
            )}
            {!oneProductOneParticipant && 
                <div class={currentTheme && currentTheme.participantFooterSubmit
                              ? currentTheme.participantFooterSubmit
                              : styles.participantFooterSubmit
                          }>
                  
                  <PrimaryButton type="submit" className="submitButton">
                    <Text id="participantClientForm.submit">Save</Text>
                  </PrimaryButton> 
              </div>
            }

        </form>
      </div>
    );
  }
}
